<!-- components/Survey/questions/MultiChoice.svelte -->
<script>
  import { surveyStore } from '../../../stores/surveyStore';
  
  export let options = [];
  export let questionId = '';
  
  // Get the current selection from the store
  $: selected = $surveyStore[questionId];
  
  // Handle option selection
  function selectOption(optionId) {
    surveyStore.update(store => ({
      ...store,
      [questionId]: optionId
    }));
  }
  
  
  // Add emoji mapping function based on your actual questions
  function getEmoji(label, questionId) {
    // Question 1: What inspires you to explore Cavs United today?
    console.log(questionId)
    console.log(label)
    if (questionId.includes('multi-choice-1')) {
      if (label.includes('memories')) return '💖';
      if (label.includes('Elevate')) return '🔝';
      if (label.includes('community')) return '👥';
      if (label.includes('Cleveland')) return '🏙️';
      if (label.includes('Entertain')) return '👪';
    }
    
    // Question 2: How many Cavs games do you typically attend?
    else if (questionId.includes('multi-choice-2') || questionId.includes('attendance')) {
      if (label.includes('1-5')) return '🎟️';
      if (label.includes('6-10')) return '🏀';
      if (label.includes('11-20')) return '🏆';
      if (label.includes('21+')) return '🔥';
    }
    
    // Question 4: Who do you typically attend Cavs games with?
    else if (questionId.includes('multi-choice-4') || questionId.includes('companions')) {
      if (label.includes('Family')) return '👨‍👩‍👧‍👦';
      if (label.includes('Friends')) return '🙌';
      if (label.includes('Colleagues') || label.includes('Work')) return '💼';
      if (label.includes('Significant')) return '❤️';
    }
    
    // Question 7: How important is playoff ticket access?
    else if (questionId.includes('multi-choice-7') || questionId.includes('playoff')) {
      if (label.includes('my membership')) return '🔥';
      if (label.includes('guaranteed')) return '🙌';
      if (label.includes('need to go')) return '😐';
      if (label.includes('really care')) return '😴';
    }
    
    // Question 10: promotions?
    else if (questionId.includes('multi-choice-10') || questionId.includes('perks')) {
          if (label.includes('Bobblehead')) return '🎁';
        if (label.includes('apparel')) return '👕';
        if (label.includes('Hoops')) return '🏀';
        if (label.includes('concerts')) return '🎶';
        if (label.includes('autographs')) return '✍️';
        if (label.includes('Community')) return '🤝';
      }

    // Question 9: Which of these perks are important?
    else if (questionId.includes('multi-choice-9') || questionId.includes('seats')) {
      if (label.includes('Discount')) return '🛍️';
      if (label.includes('events')) return '✨';
      if (label.includes('playoff')) return '🎟️';
      if (label.includes('specialist')) return '👤';
      if (label.includes('fees')) return '🧾';
      if (label.includes('food')) return '🍽️';
      if (label.includes('exchange')) return '🔄';
    }
    
    // Default emoji for any other questions
    return '🏀';
  }
</script>

<div class="multi-choice">
  {#each options as option (option.id)}
    <div 
      class="option-item {selected === option.id ? 'selected' : ''}"
      on:click={() => selectOption(option.id)}
      on:keypress={(e) => e.key === 'Enter' && selectOption(option.id)}
      tabindex="0"
      role="button"
      aria-pressed={selected === option.id}
    >
      <div class="radio-button">
        {#if selected === option.id}
          <div class="radio-inner"></div>
        {/if}
      </div>
      <div class="option-label">
        <span class="option-emoji">{getEmoji(option.label, questionId)}</span> {option.label}
      </div>
    </div>
  {/each}
</div>

<style>
  .multi-choice {
    display: flex;
    flex-direction: column;
    gap: 1rem;
  }
  
  .option-item {
    display: flex;
    align-items: center;
    padding: 1rem;
    border: 2px solid #e0e0e0;
    border-radius: 8px;
    cursor: pointer;
    transition: all 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275);
  }
  
  .option-item:hover {
    border-color: #FFB81C; /* Monsters gold color */
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  }
  
  .selected {
    border-color: #FFB81C; /* Monsters blue color */
    background-color: rgba(2, 0, 134, 0.05);
    transform: scale(1.03);
    box-shadow: 0 8px 16px rgba(0, 0, 134, 0.2);
    animation: selectedPulse 2s infinite;
  }
  
  @keyframes selectedPulse {
    0% {
      box-shadow: 0 4px 12px rgba(0, 0, 134, 0.2);
    }
    50% {
      box-shadow: 0 4px 18px rgba(0, 0, 134, 0.2);
    }
    100% {
      box-shadow: 0 4px 12px rgba(0, 0, 134, 0.2);
    }
  }
  
  .radio-button {
    width: 20px;
    height: 20px;
    border-radius: 50%;
    border: 2px solid #999;
    margin-right: 1rem;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    transition: all 0.3s ease;
  }
  
  .selected .radio-button {
    border-color: #FFB81C;
    transform: scale(1.1);
  }
  
  .radio-inner {
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background-color: #FFB81C;
    animation: popIn 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275);
  }
  
  @keyframes popIn {
    0% {
      transform: scale(0);
      opacity: 0;
    }
    70% {
      transform: scale(1.2);
    }
    100% {
      transform: scale(1);
      opacity: 1;
    }
  }
  
  /* Add to existing styles */
  @media (max-width: 768px) {
    .option-item {
      padding: 0.75rem 0.5rem;
    }
    
    .option-emoji {
      font-size: 1rem;
      margin-right: 0.35rem;
    }
    
    .radio-button {
      width: 18px;
      height: 18px;
      margin-right: 0.5rem;
    }
  }
  
  .option-emoji {
    font-size: 1.2rem;
    margin-right: 0.5rem;
    display: inline-block;
  }
  
  .option-label {
    font-size: 1rem;
    color: #333;
  }
</style>